import React from 'react'
import { View } from 'react-native'
import { Radio, Text } from '@ui-kitten/components'
import { Controller } from 'react-hook-form'

export default function FormRadio({
  control,
  name,
  options,
  style,
  radioStyle,
  label,
  rightAccessory,
  labelAccessory,
  testID,
}) {
  // Support backward compatibility while transitioning to new prop name
  const accessoryToUse = labelAccessory || rightAccessory

  return (
    <>
      {label && (
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Text category='label' style={{ marginTop: 15, marginBottom: 5 }}>
            {label}
          </Text>
          {accessoryToUse && accessoryToUse()}
        </View>
      )}
      <Controller
        name={name}
        control={control}
        render={({field: { onChange, value }}) => (
          <View style={style}>
            {options.map((option, index) => (
              <Radio
                key={option.value}
                style={{...radioStyle, marginBottom: index < options.length - 1 ? 5 : 0}}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
                testID={testID ? `${testID}-${option.value}` : undefined}
              >
                {option.label}
              </Radio>
            ))}
          </View>
        )}
      />
    </>
  )
} 